import React, {useState} from 'react';
import {Button, Form} from "react-bootstrap";
import PropTypes from "prop-types";
import FormGroup from "../components/formGroup";
import {isObject} from "lodash";
import MySelect from "../components/form/mySelect";

function MoyenContact(props) {

    const [validated, doValidate] = useState(false);

    const [typeMoyenContact, updateTypeMoyenContact] = useState(
        isObject(props.item.TypeMoyenContactID)
            ? props.item.TypeMoyenContactID
            : props.parameters.TypeMoyenContactID.find(f => f.value === props.item.TypeMoyenContactID)
    );

    const save = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (event.currentTarget.checkValidity() === false) {
            doValidate(!event.currentTarget.checkValidity())
        } else {
            const data = new FormData(event.currentTarget);
            props.save(Object.fromEntries(data));
        }
    };

    return (
        <Form key={props.item.MoyenContactID} noValidate
              validated={validated}
              onSubmit={save.bind(this)}>

            <FormGroup label={"Type"}
                       name={"TypeMoyenContactID"}
                       type={MySelect}
                       value={typeMoyenContact}
                       options={props.parameters.TypeMoyenContactID}
                       onChange={updateTypeMoyenContact}
                       required={true}/>

            <FormGroup label={"Valeur du moyen de contact"}
                       name={"MoyenContactValeur"}
                       defaultValue={props.item.MoyenContactValeur}
                       required={true}/>

            <Button type="submit"
                    variant="success"
                    size={"lg"}
                    className={"mr-3"}
                    block>
                Sauvegarder
            </Button>
        </Form>
    )
}

MoyenContact.propTypes = {
    save: PropTypes.func.isRequired,
};

export default MoyenContact;